import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatCurrency' })
export class FormatCurrencyPipe implements PipeTransform {
  transform(number?: number): string {
    if (number === 0) return '$0.00';
    else if (number && number < 0) return `-\$${Math.abs(number).toFixed(2)}`;
    else if (number && number > 0) return `\$${number.toFixed(2)}`;
    else return '';
  }
}
